type NameInput = {
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
};

export const formatName = (input?: NameInput | null): string => {
  if (!input) return "";
  if (input.firstName && input.lastName) {
    return `${input.firstName} ${input.lastName}`;
  }
  return input.name || "";
};
